// @flow
import moment from 'moment'
// ES not needed! reduce bundle size
// import 'moment/locale/es'

moment.locale('en')

export const SECOND = 1000
export const MINUTE = SECOND * 60
export const HOUR = MINUTE * 60
export const DAY = HOUR * 24

export const calculateTimeFromNow = (date: string): string => {
  return moment(date).fromNow()
}

export const milisecondsFromNow = (date: string): number =>
  moment(date) - moment()

export const buildDateObjectFromDateAndTime = (
  dateString: string,
  timeString: string
) => moment(`${dateString} ${timeString}`, 'MM-DD-YYYY hh:mm A').utc()

export default moment



// WEBPACK FOOTER //
// ./src/core/moment.js